import useLazyData from '@/hooks/useLazyData';
import Skeleton from './skeleton';
import ProductList from './feed-list';

const ContentFeedV2 = props => {
  const { ref: viewRef, show } = useLazyData({
    threshold: 0.01,
    rootMargin: '10px 0px 0px 0px'
  });

  const skeleton = <Skeleton />;

  return <div ref={viewRef}>{show ? <ProductList skeleton={skeleton} {...props} /> : skeleton}</div>;
};

export default ContentFeedV2;
